
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";


function GeneralRecallDesign2() {
  const [selectedValue, setSelectedValue] = useState("");
  const [positionsList, setPositionsList] = useState([]);
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const InRoute = 'I';
  // console.log("positionsList===>22",positionsList,selectedValue)

  const fetchUserRecallList = async () => {
    try {
      setLoading(true);
      const response = await ApiService.get('/general-recall/employee-list');
      // console.log("response===>123",response,response?.data.data)
      if (response.status === 200) {
        setUserData(response?.data?.data);
        const locations = Object.entries(response?.data?.arr_location).map(
          ([key, value]) => ({
            code: key,
            label: value,
          })
        );

  setPositionsList(locations);
      }
    } catch (error) {
      console.log("List Error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserRecallList();
  }, [])
  


  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  // const handleInQuartersClick = async () => {
  //   try {
  //     if (!userData || userData.length === 0) {
  //       // console.log("User data not loaded yet!");
  //       toast.error('User data not loaded yet!')
  //       return;
  //     }
  //     const payload = {
  //       Shift_Date: userData.Shift_Date,
  //       Shift_Number: userData.Shift_Number,
  //       Response: InRoute,
  //       Log_Text: selectedValue
  //     };

  //     const res = await ApiService.post("/general-recall/employee-response", payload);

  //     if (res.status) {
  //       toast.success(res.message || 'Response recorded successfully')
  //       setSelectedValue("");

  //     }
  //     // console.log("payload===>185", res, payload);

  //   } catch (err) {
  //     toast.error(err.data.errors)
  //     console.log("Search API Error:", err);
  //   }
  // };

const handleInQuartersClick = async () => {

  // Check dropdown is selected
  if (!selectedValue) {
    toast.error("Please select any location first!");
    return;
  }

  // Show confirm popup
  const confirmResult = window.confirm("In Quarters?");
  if (!confirmResult) return;

  try {
    if (!userData || userData.length === 0) {
      toast.error('User data not loaded yet!');
      return;
    }

    const payload = {
      Shift_Date: userData.Shift_Date,
      Shift_Number: userData.Shift_Number,
      Response: InRoute,
      Log_Text: selectedValue, // sending selected value like STN2
    };

    const res = await ApiService.post("/general-recall/employee-response", payload);

    if (res.status) {
      toast.success(res.message || 'Response recorded successfully');
      setSelectedValue("");
    }

  } catch (err) {
    toast.error(err?.data?.errors || "Something went wrong");
    console.log("Error:", err);
  }
};


  return (
    <Box
      sx={{
        padding: 3,
        border: "1px solid #ccc",
        margin: "20px auto",
        backgroundColor: "white",
        // maxWidth: 400,
      }}
    >
      {/* ---- Title ---- */}
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3 }}>
        General Recall in Progress
      </Typography>

      {/* ---- Dropdown + Button ---- */}
      <Stack direction="column" spacing={2} alignItems="flex-start">
        {/* Dropdown */}
        <FormControl variant="outlined" size="small" sx={{ minWidth: 180 }}>
         <Select
  value={selectedValue}
  onChange={handleChange}
  displayEmpty
>
  <MenuItem value="">
    Select...
  </MenuItem>

  {positionsList.map((item, index) => (
    <MenuItem key={index} value={item.label}>
      {item.label}
    </MenuItem>
  ))}
</Select>

        </FormControl>

        {/* Button */}
        <Button
          variant="contained"
          onClick={handleInQuartersClick}
          sx={{
            backgroundColor: "#ccc",
            color: "black",
            "&:hover": { backgroundColor: "#bbb" },
          }}
        >
          In Quarters
        </Button>
      </Stack>
    </Box>
  );
}

export default GeneralRecallDesign2;


